import { useEffect, useState } from 'react';
import { useRecoilValue, useResetRecoilState } from 'recoil';
import { WSPScorecardService } from '../../../../Component/Api/WSPScorecard/WSPScorecardService';
import { DataTable } from '../../../../Component/Common/Components/DataTable/DataTable';
import { TooltipLoadingButton } from '../../../../Component/Common/Components/Tooltip/TooltipLoadingButton';
import { SubAdminRole, UserAdminRole } from '../../../../Component/Common/Constants/UserRoles';
import { WSPScorecardDto } from '../../../../Component/Model/Dto/ScorecardLicense';
import { EntriesPerPage } from '../../../../Component/Model/Table/Table';
import { defaultObject } from '../../../../Helpers/typescriptHelper';
import { BBBEEScorecardAtom } from '../../../../State/BBBEEScorecard.Atom';
import { ConsolidationAtom } from '../../../../State/Consolidation.Atom';
import { EEScorecardAtom } from '../../../../State/EEScorecard.Atom';
import { OrganisationAtom } from '../../../../State/Organisation.Atom';
import { ScorecardAtom } from '../../../../State/Scorecard.Atom';
import { WSPScorecardAtom } from '../../../../State/WSPScorecard.Atom';
import { userRolesState } from '../../../../State/user.Atom';
import { CreateSetaScorecard } from '../CreateScorecardModal/CreateSetaScorecard';
import { WSPScorecardsTableMapper } from './WSPScorecardsTableColumns';
import { Typography } from '@mui/material';
import { ClientRegistrationAtom } from '../../../../State/Advisory/ClientRegistration.Atom';

export const WSPScorecardPage = () => {
    const [wspScorecardData, setWSPScorecardData] = useState<WSPScorecardDto[]>(defaultObject);
    const [entriesPerPage, setEntriesPerPage] = useState<EntriesPerPage>({ defaultValue: 5 });
    const [totalItemsCount, setTotalItemsCount] = useState<number>(1);
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [searchValue, setSearchValue] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [filteredItemsCount, setfilteredItemsCount] = useState<number>(0);
    const [openCreateSetaScorecard, setOpenCreateSetaScorecard] = useState<boolean>(false);
    const [isAdminTypeRole, setIsAdminTypeRole] = useState<boolean>(false);
    const userRoles = useRecoilValue(userRolesState);


    const resetScorecard = useResetRecoilState(ScorecardAtom);
    const resetScorecardData = useResetRecoilState(EEScorecardAtom);
    const resetScorecardType = useResetRecoilState(ConsolidationAtom);
    const resetWSPScorecard = useResetRecoilState(WSPScorecardAtom);
    const resetClientRegistration = useResetRecoilState(ClientRegistrationAtom);
    const resetOrganisation = useResetRecoilState(OrganisationAtom)
    const resetBBBEEScorecard = useResetRecoilState(BBBEEScorecardAtom);

    const openModal = () => {
        setOpenCreateSetaScorecard(true)
    }

    const closeModal = () => {
        setOpenCreateSetaScorecard(false);
        fetchData();
    }

    const fetchData = async () => {
        if (userRoles.includes(UserAdminRole) || userRoles.includes(SubAdminRole)) {
            setIsAdminTypeRole(true);
        }
        setIsLoading(true);
        try {
            let wspScorecardsResult = await WSPScorecardService.getWSPScorecards(searchValue, pageNumber, entriesPerPage.defaultValue!);

            if (wspScorecardsResult.data.results != undefined && wspScorecardsResult.data.results.length > 0) {
                setWSPScorecardData(wspScorecardsResult.data.results);
                setTotalItemsCount(wspScorecardsResult.data.totalItemsCount);
                setfilteredItemsCount(wspScorecardsResult.data.filteredItemsCount);
            }
        } catch (error) {
            console.log(error);
            setWSPScorecardData(defaultObject);
            setTotalItemsCount(1);
        } finally {
            setIsLoading(false);
        }
    }


    const pageNumberChanged = (pageNumber: number) => {
        setPageNumber(pageNumber);
    }
    const entriesPerPageChanged = (entries: number) => {
        setEntriesPerPage({ defaultValue: entries });
        setPageNumber(1);
    }

    const searchValueChanged = (value: string) => {
        setSearchValue(value);
        setPageNumber(1);
    };

    useEffect(() => {
        fetchData();
    }, [entriesPerPage, pageNumber, searchValue]);

    useEffect(() => {
        resetScorecard();
        resetScorecardData();
        resetScorecardType();
        resetWSPScorecard();
        resetClientRegistration();
        resetOrganisation();
        resetBBBEEScorecard();
    }, []);


    const tableData = WSPScorecardsTableMapper(wspScorecardData);
    return (
        <>

            <Typography variant="h4" style={{ paddingBottom: "20px" }}>
                WSP/ATR Scorecards
            </Typography>
            <TooltipLoadingButton
                buttonText='Create Scorecard'
                tooltipTitle='Please contact an administrator within your registration to create a scorecard'
                disabled={!isAdminTypeRole}
                showTooltipOnDisabled={true}
                onClick={() => openModal()}
                isLoading={false}
                position='right'
            />
            <CreateSetaScorecard open={openCreateSetaScorecard} closeModal={closeModal} />
            <DataTable
                table={tableData}
                entriesPerPage={entriesPerPage}
                entriesPerPageChanged={entriesPerPageChanged}
                pageNumber={pageNumber}
                isSorted={false}
                pageNumberChanged={pageNumberChanged}
                filteredItemsCount={filteredItemsCount}
                totalItemsCount={totalItemsCount}
                isLoading={isLoading}
                searchValueChanged={searchValueChanged}
                canSearch={true}
                showSearchBoxInfoIcon={true}
                searchBoxInfoIconTooltipText='Search by Name and Organisation.'
            />
        </>
    )
}
